import { defaultFeePercent } from '@constants'
import { isObject } from '@utils/type-checkers'


const parsePledge = (data?: Partial<Pledge>): Pledge => ({
    amount: data?.amount || 0,
    chargedToCard: data?.chargedToCard || 0,
    createdAt: data?.createdAt || new Date().toISOString(),
    fee: isObject(data?.fee) ? parsePledgeFee(data?.fee) : undefined,
    id: data?.id || '',
    name: data?.name || '',
    paymentMethod: isObject(data?.paymentMethod) ? data.paymentMethod : undefined, // ToDo: Create parsePaymentMethod Schema
    suggested: data?.suggested || undefined,
    transactionId: data?.transactionId,
    updatedAt: data?.updatedAt || "0001-01-01T00:00:00Z",
    user: isObject(data?.user) ? data.user : undefined, // ToDo: Create parseUser Schema
    userId: data?.userId,
    additionalCharge: data?.additionalCharge || false,
    additionalCharges: data?.additionalCharges || [],
    useCredit: data?.useCredit || false,
})

const parsePledgeFee = (data?: Partial<PledgeFee>): PledgeFee => ({
    amount: data?.amount || 0,
    percentage: data?.percentage || defaultFeePercent,
    transactionId: data?.transactionId || ''
})

export { parsePledge, parsePledgeFee }
